import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Group = makeShortcode("Group");
const Item = makeShortcode("Item");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Data related to 3D Secure authentication for the transaction.`}</p>
    <Group summary='Properties' mdxType="Group">
      <Item title='responseCode' subtitle='ThreeDSecureStatus' mdxType="Item">
        <p>{`Indicates the outcome of the 3D Secure authentication process.`}<br parentName="p"></br>{`
`}{`Possible values:  `}</p>
        <ul>
          <li parentName="ul"><inlineCode parentName="li">{`AUTH_SUCCESS`}</inlineCode>{`: The authentication was successful.  `}</li>
          <li parentName="ul"><inlineCode parentName="li">{`AUTH_FAILED`}</inlineCode>{`: The authentication process failed.  `}</li>
          <li parentName="ul"><inlineCode parentName="li">{`SKIPPED`}</inlineCode>{`: The authentication was skipped.  `}</li>
          <li parentName="ul"><inlineCode parentName="li">{`CHALLENGE`}</inlineCode>{`: A challenge was issued during the authentication process.  `}</li>
        </ul>
      </Item>
      <Item title='reasonCode' subtitle='string' mdxType="Item">
An optional code indicating the reason for the outcome of the 3D Secure authentication.
      </Item>
      <Item title='reasonText' subtitle='string' mdxType="Item">
An optional text description providing further details about the reason for the authentication outcome.
      </Item>
      <Item title='protocolVersion' subtitle='string' mdxType="Item">
Specifies the version of the 3D Secure protocol that was used.
      </Item>
      <Item title='challengeIssued' subtitle='boolean' mdxType="Item">
        <p>{`Indicates whether a challenge was issued as part of the authentication process.  `}</p>
        <ul>
          <li parentName="ul"><inlineCode parentName="li">{`true`}</inlineCode>{`: A challenge was issued.  `}</li>
          <li parentName="ul"><inlineCode parentName="li">{`false`}</inlineCode>{`: No challenge was issued.`}</li>
        </ul>
      </Item>
    </Group>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      